import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { useBenefisUIContext } from "./BenefisUIContext";
import BenefisTable from "./benefis-table/BenefisTable";
import { BenefisFilter } from "./benefis-filter/BenefisFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const BenefisCard = () => {
  const benefisUIContext = useBenefisUIContext();
  const benefisUIProps = useMemo(() => {
    return {
      newBenefisIndividuButtonClick:
        benefisUIContext.newBenefisIndividuButtonClick,
      newBenefisOrganizationButtonClick:
        benefisUIContext.newBenefisOrganizationButtonClick,
      openImportBenefisIndividuPage:
        benefisUIContext.openImportBenefisIndividuPage,
      openImportBenefisOrganizationPage:
        benefisUIContext.openImportBenefisOrganizationPage
    };
  }, [benefisUIContext]);

  return (
    <Card>
      <CardHeader className="mt-8" title="Kategori Penerima Manfaat">
        <CardHeaderToolbar className="mt-5 mb-5">
          {RoleChecker("Create", "benefis_category") && (
            <button
              type="button"
              className="btn btn-outline-success ml-4"
              onClick={benefisUIProps.openImportBenefisIndividuPage}
            >
              Import Data Individu
            </button>
          )}
          {RoleChecker("Create", "benefis_category") && (
            <button
              type="button"
              className="btn btn-outline-primary ml-4"
              onClick={benefisUIProps.openImportBenefisOrganizationPage}
            >
              Import Data Kelompok
            </button>
          )}

          {BlockOrg() && RoleChecker("Create", "benefis_category") && (
            <button
              type="button"
              className="btn btn-outline-success ml-4"
              onClick={benefisUIProps.newBenefisOrganizationButtonClick}
            >
              Tambah Kelompok
            </button>
          )}
          {BlockOrg() && RoleChecker("Create", "benefis_category") && (
            <button
              type="button"
              className="btn btn-outline-primary ml-4"
              onClick={benefisUIProps.newBenefisIndividuButtonClick}
            >
              Tambah Individu
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <BenefisFilter />
        <BenefisTable />
      </CardBody>
    </Card>
  );
};
